import RaisedStyleContainer from "../../../Components/Buttons/RaisedStyle/RaisedStyle"

const RaisedStyle = () => {
  return (
    <div className='page-body'>
      <RaisedStyleContainer />
    </div>
  )
}

export default RaisedStyle